var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "menu"
  }, [_c("el-menu", {
    ref: "menu",
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex,
      mode: "horizontal",
      "background-color": "#FFFFFF",
      "text-color": "#000000",
      "active-text-color": "#000000"
    },
    on: {
      select: _vm.handleSelect
    }
  }, [_vm._l(_vm.routerList, function (item) {
    return [item.child && item.child.length ? _c("el-submenu", {
      key: item.path,
      attrs: {
        index: item.path
      }
    }, [_c("template", {
      slot: "title"
    }, [_vm._v(_vm._s(item.routerName))]), _vm._l(item.child, function (childItem) {
      return _c("el-menu-item", {
        key: childItem.id,
        staticStyle: {
          "font-size": "16px",
          "font-weight": "400",
          "font-family": "PingFang-SC-Regular, PingFang-SC",
          "letter-spacing": "1px"
        },
        attrs: {
          index: childItem.path
        }
      }, [childItem.path == _vm.selectIndex ? _c("span", {
        staticClass: "highlight"
      }) : _c("span", {
        staticClass: "occupySpace"
      }), _c("span", [_vm._v(_vm._s(childItem.routerName))])]);
    })], 2) : _c("el-menu-item", {
      key: item.id,
      attrs: {
        index: item.path
      }
    }, [_vm._v(_vm._s(item.routerName))])];
  })], 2), _c("div", {
    staticClass: "businessProcess",
    class: {
      businessProcessActive: _vm.processCode
    }
  }, [_c("div", {
    staticClass: "process",
    on: {
      mouseenter: _vm.toprocessbox,
      mouseleave: _vm.leaveprocessbox
    }
  }, [_c("div", {
    staticClass: "title"
  }, [_c("span", [_vm._v("业务流程")]), _vm.showBusinessProcess == false ? _c("i", {
    staticClass: "el-icon-arrow-down"
  }) : _c("i", {
    staticClass: "el-icon-arrow-up"
  })]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.processBoxShow,
      expression: "processBoxShow"
    }],
    staticClass: "processDetail"
  }, _vm._l(_vm.processList, function (item, index) {
    return _c("div", {
      on: {
        click: function ($event) {
          return _vm.toProcess(item);
        }
      }
    }, [item.value == _vm.processCode ? _c("span", {
      staticClass: "highlight"
    }) : _c("span", {
      staticClass: "occupySpace"
    }), _c("span", [_vm._v(_vm._s(item.name))])]);
  }), 0)])])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };